// Os ids são os do enum `attribute_model` do CustomAttributeDefinition. A aba
// de Negócios só chega no modal por aqui: sem a entrada `DEAL`, o `select`
// abria em branco e o atributo era salvo como conversa/contato — o campo
// existia e nunca aparecia no card.
export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
  { id: 2, key: 'DEAL' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
];
